module.exports = __webpack_public_path__ + "static/shepperd-fox-logo-black-5385a30ceef48d43742fd801da9c39a7.svg";